export function createIntervalController() {
  let intervalId = null
  let intervalKey = null

  function stop() {
    if (intervalId !== null) {
      clearInterval(intervalId)
    }
    intervalId = null
    intervalKey = null
  }

  function run(key, callback, interval = null) {
    if (intervalId !== null && intervalKey !== key) {
      stop()
    }

    callback()

    if (interval !== null && intervalId === null) {
      intervalKey = key
      intervalId = setInterval(callback, interval)
    }
  }

  function isRunning() {
    return intervalId !== null
  }

  function getKey() {
    return intervalKey
  }

  return {
    run,
    stop,
    isRunning,
    getKey,
  }
}
